import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { Icons, MUI, Typography } from '@styles';

const TwoFactorForm = (props) => {
  const handleCodeChange = (event) => {
    const nextValue = event.target.value.replace(/\D/g, '').slice(0, 6);
    props.setFieldValue('code', nextValue);
  };

  return (
    <Styled.Form onSubmit={props.handleSubmit}>
      <Styled.Section>
        <Typography.Text color="greyDarkAlpha">
          {i18n.t('Login.twoFactorPending')}
        </Typography.Text>
        <Typography.Text color="greyDarkAlpha">
          {i18n.t('Login.twoFactorNextStep')}
        </Typography.Text>
        <Styled.MessageSpacing />
        <Typography.Text color="greyDarkAlpha">
          {i18n.t('Login.twoFactorSentTo')}
        </Typography.Text>
        <Typography.Medium>{props.maskedEmail || '-'}</Typography.Medium>
      </Styled.Section>

      <Styled.Section>
        <MUI.TextFieldIcon
          label={i18n.t('Login.twoFactorCode')}
          type="text"
          name="code"
          value={props.values.code}
          onBlur={props.handleBlur}
          onChange={handleCodeChange}
          onInput={() => props.setFieldTouched('code', true, true)}
          error={Boolean(props.touched.code && props.errors.code)}
          helperText={(props.touched.code && props.errors.code) || i18n.t('Login.twoFactorCodeHelp')}
          InputProps={{ startAdornment: (<Icons.Lock />) }}
        />
      </Styled.Section>

      <Styled.Section>
        <MUI.CheckboxLabel
          label={i18n.t('Login.rememberDevice')}
          control={(
            <MUI.Checkbox
              checked={props.rememberDevice}
              onChange={props.onRememberDeviceChange}
            />
          )}
        />
        {/* <Typography.Small color="greyDarkAlpha">
          {i18n.t('Login.rememberDeviceHelp')}
        </Typography.Small> */}
      </Styled.Section>

      <Styled.Section style={{ display: 'flex', gap: '8px' }}>
        <MUI.Grid container spacing={2}>
          <MUI.Grid item xs={12} sm={6}>
            <Typography.Small color="greyDarkAlpha">
              {props.isExpired
                ? i18n.t('Login.twoFactorExpired')
                : i18n.t('Login.twoFactorExpiresIn', { time: props.expiresInText })}
            </Typography.Small>
          </MUI.Grid>
          {props.challengeErrorMessage ? (
            <MUI.Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Styled.ErrorText color="red">{props.challengeErrorMessage}</Styled.ErrorText>
            </MUI.Grid>
          ) : null}
        </MUI.Grid>
        {/* <Typography.Small color="greyDarkAlpha">
          {props.isExpired
            ? i18n.t('Login.twoFactorExpired')
            : i18n.t('Login.twoFactorExpiresIn', { time: props.expiresInText })}
        </Typography.Small>
        {props.challengeErrorMessage ? (
          <Styled.ErrorText color="red">{props.challengeErrorMessage}</Styled.ErrorText>
        ) : null} */}
      </Styled.Section>

      <Styled.ActionsSection>
        <MUI.Grid container spacing={2}>
          <MUI.Grid item xs={12} sm={6}>
            <MUI.ButtonCTA
              type="submit"
              color="primary"
              fullWidth
              disabled={!props.isValid || props.isSubmitting || props.isExpired}
              margin="false"
            >
              {props.isSubmitting ? i18n.t('Login.twoFactorVerifying') : i18n.t('Login.twoFactorVerify')}
            </MUI.ButtonCTA>
          </MUI.Grid>
          <MUI.Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {props.canResend ?
              <MUI.ButtonLink
                type="button"
                onClick={props.onResend}
                fullWidth
                margin="false"
                disabled={!props.canResend || props.isResending || props.isExpired}
              >
                {props.isResending ? i18n.t('Login.twoFactorResending') : i18n.t('Login.twoFactorResend')}
              </MUI.ButtonLink>
              : i18n.t('Login.twoFactorResendIn', { time: props.resendInText })}
          </MUI.Grid>
        </MUI.Grid>
      </Styled.ActionsSection>
    </Styled.Form>
  );
};

TwoFactorForm.propTypes = {
  values: PropTypes.any,
  errors: PropTypes.any,
  touched: PropTypes.any,
  isValid: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  maskedEmail: PropTypes.string,
  expiresInText: PropTypes.string,
  resendInText: PropTypes.string,
  challengeErrorMessage: PropTypes.string,
  canResend: PropTypes.bool,
  isExpired: PropTypes.bool,
  isResending: PropTypes.bool,
  onResend: PropTypes.func,
  rememberDevice: PropTypes.bool,
  onRememberDeviceChange: PropTypes.func
};

const Styled = {};

Styled.Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  height: 100%;
  min-height: 0;
  width: 100%;
`;

Styled.Section = styled.div`
  width: 100%;
`;

Styled.ActionsSection = styled.div`
  width: 100%;
`;

Styled.MessageSpacing = styled.div`
  height: 8px;
`;

Styled.ErrorText = styled(Typography.Small)`
  margin-top: 8px;
`;

export default TwoFactorForm;
